export const HOST = process.env.REACT_APP_API_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

export const API_ROOT = HOST + "/" + VERSION;
